import React from "react";
import Sidebar from "./sidebar";
import Topbar from "./topbar";
import Header from "./header";
import CountdownTimer from "./CountdownTimer";
import styled, { css } from "styled-components";

/** Viewports below Tailwind `lg` (1024px); desktop layout unchanged */
const nonDesktop = (styles) => css`
    @media only screen and (max-width: 1023px) {
        ${css(styles)}
    }
`;

const ScrollContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 60px;
    border: none;
    background-color: #d3233e;
    font-size: 22vt;
    font-family: "Poppins", sans-serif;
    color: white;
    overflow: hidden;
    ${nonDesktop({
        minHeight: "52px",
        height: "auto",
        padding: "8px 0",
        overflow: "visible",
    })}
`;

const ScrollText = styled.div`
text-align: center;
display: block;
cursor: pointer;
color: white;
font-weight: 600;
${nonDesktop({ display: "none" })}
/* animation properties */
-moz-transform: translateX(-100%);
-webkit-transform: translateX(-100%);
transform: translateX(-100%);

-moz-animation: my-animation 15s linear infinite;
-webkit-animation: my-animation 15s linear infinite;
animation: my-animation 15s linear infinite;
}

/* for Firefox */
@-moz-keyframes my-animation {
from { -moz-transform: translateX(-100%); }
to { -moz-transform: translateX(100%); }
}

/* for Chrome */
@-webkit-keyframes my-animation {
from { -webkit-transform: translateX(-100%); }
to { -webkit-transform: translateX(100%); }
}

@keyframes my-animation {
from {
  -moz-transform: translateX(-100%);
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
}
to {
  -moz-transform: translateX(100%);
  -webkit-transform: translateX(100%);
  transform: translateX(100%);
}


`;

/* Mobile: static, readable banner (marquee clipped text on narrow screens) */
const MobileBannerText = styled.div`
    display: none;
    ${nonDesktop({
        display: "block",
        width: "100%",
        boxSizing: "border-box",
        padding: "0 14px",
        textAlign: "center",
        lineHeight: "1.45",
        fontSize: "13px",
        fontWeight: "600",
        color: "white",
        cursor: "pointer",
    })}
`;

const Layout = (props) => {
    return (
        <main className="shared-background min-h-screen">
            <div className="lg:hidden">
                <Header />
            </div>
            <ScrollContainer>
                <ScrollText
                    onClick={() =>
                        (window.location.href = "/announcements")
                    }
                >
                    D&Dream Announcement - Important Message from Management -{" "}
                    <span className="text-yellow-300 font-bold p-2 rounded-full">
                        {" "}
                        Click Here To View
                    </span>{" "}
                </ScrollText>
                <MobileBannerText
                    onClick={() =>
                        (window.location.href = "/announcements")
                    }
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            window.location.href = "/announcements";
                        }
                    }}
                >
                    D&Dream — Message from Management —{" "}
                    <span className="text-yellow-300 font-bold underline">
                        Click here to view
                    </span>
                </MobileBannerText>
            </ScrollContainer>
            <div className="z-30 flex flex-auto h-full w-full relative min-h-screen">
                <Sidebar />
                <div className="wrapper w-full lg:w-10/12 flex flex-col">
                    <div className="layout-countdown-banner flex items-center justify-center lg:py-2 lg:px-4 bg-transparent w-full">
                        <div className="flex items-center justify-center w-full lg:py-2 lg:px-8 max-w-full">
                            <CountdownTimer />
                        </div>
                    </div>
                    <Topbar className="flex-grow-0" />
                    <div className="content w-full flex-grow">
                        {props.children}
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Layout;
